var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{attrs:{"id":"card-errors","role":"alert"}},[_c('p',{staticClass:"mbn mtm"},[_c('i',{staticClass:"fas fa-times-circle"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.error)}})])]):_c('div',[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }